/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Option_StyleInputs */



/**
* | output |
* | --- |
* | "Style" |
*
* @param {Compare_Event_Groups_Option_StyleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_option_style = /** @type {((inputs?: Compare_Event_Groups_Option_StyleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Option_StyleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стиль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("风格")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शैली")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Estilo")
	return /** @type {LocalizedString} */ ("Style")
});